/**
 * Merges first + last name into contact[name] for appointment layout; basic reCAPTCHA check if present.
 */
function initAppointmentContactForm(root) {
  const form = root.querySelector('form');
  if (!form) return;

  const hiddenName = form.querySelector('[data-merge-name-target]');
  const first = form.querySelector('[data-first-name]');
  const last = form.querySelector('[data-last-name]');

  const mergeName = () => {
    if (!hiddenName) return;
    const a = first instanceof HTMLInputElement ? first.value.trim() : '';
    const b = last instanceof HTMLInputElement ? last.value.trim() : '';
    hiddenName.value = [a, b].filter(Boolean).join(' ');
  };

  form.addEventListener('input', mergeName);

  form.addEventListener('submit', (event) => {
    mergeName();
    if (hiddenName && !hiddenName.value.trim()) {
      event.preventDefault();
      first?.focus();
      return;
    }

    const recaptcha = form.querySelector('.g-recaptcha');
    if (recaptcha && typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.getResponse === 'function') {
      const response = window.grecaptcha.getResponse();
      if (!response) {
        event.preventDefault();
      }
    }
  });
}

function initAll() {
  document.querySelectorAll('[data-contact-form-appointment]').forEach((root) => {
    if (root instanceof HTMLElement) initAppointmentContactForm(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  event.target.querySelectorAll('[data-contact-form-appointment]').forEach((root) => {
    if (root instanceof HTMLElement) initAppointmentContactForm(root);
  });
});
